import { getCurrentScriptUrl } from './getCurrentScriptUrl';

export const ROSETTE_PROD_CTI = 'SantosNebulaRosette';
export const ROSETTE_GAMMA_CTI = 'SantosNebulaRosetteGamma';

export const IS_PROD = getCurrentScriptUrl().hostname === 'cdn.elements.amazon';
